import { Component, input } from '@angular/core';

@Component({
  selector: 'td-wb-horizontal-toolbar',
  templateUrl: 'horizontal-toolbar.component.html',
  styleUrls: ['horizontal-toolbar.component.scss'],
  host: {
    '[class.td-wb-horizontal-toolbar--left]': 'position() === \'left\'',
    '[class.td-wb-horizontal-toolbar--center]': 'position() === \'center\''
  }
})
export class HorizontalToolbarComponent {
  readonly position = input<'left' | 'center' | 'right'>('right');

  constructor() {
  }
}
